import { BASE_URL, BASE_URL_DEV } from "../_constants/urlConstants";
const { buildErrResponse } = require("../_utils/utils");
const { default: Axios } = require("axios");

export const ProviderService = {
  createProvider,
  getAllProviders,
  getProviderById,
  getAllProvidersActive,
  updateProvider,
  deleteProvider,
};

function createProvider(body) {
  console.log("createprovider", body);
  return new Promise((resolve, reject) => {
    Axios.post(`${BASE_URL_DEV}/provider`, body)
      .then((resp) => {
        console.log(resp);
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAllProviders() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/provider`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getProviderById(id) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/provider/id?id=${id}`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAllProvidersActive() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/provider/active`)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function updateProvider(body) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/provider`, body)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function deleteProvider(providerArrayId) {
  return new Promise((resolve, reject) => {
    Axios.patch(`${BASE_URL_DEV}/provider/`, providerArrayId)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}
